var _rect, _rect2, _rect3, _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgTextSlate(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 476,
    height: 101,
    viewBox: "0 0 476 101",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.75,
    y: 0.75,
    width: 474.5,
    height: 99.5,
    rx: 20.75,
    fill: "black"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 0.75,
    y: 0.75,
    width: 474.5,
    height: 99.5,
    rx: 20.75,
    stroke: "#6D5E57",
    strokeWidth: 1.5
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 5.5,
    y: 5.5,
    width: 465,
    height: 90,
    rx: 18,
    fill: "#7E0822"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_46_240)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 23.5,
    y: 13.5,
    width: 429,
    height: 74,
    rx: 8,
    fill: "#F9EEDF",
    shapeRendering: "crispEdges"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M63.5 25.5H34.7713L28.5 18.5H57.2287L63.5 25.5Z",
    fill: "#790320"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M69.3013 25.5H78.5L72.6987 18.5H63.5L69.3013 25.5Z",
    fill: "#790320"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M84.3013 25.5H93.5L87.6987 18.5H78.5L84.3013 25.5Z",
    fill: "#790320"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M99.3013 25.5H108.5L102.699 18.5H93.5L99.3013 25.5Z",
    fill: "#790320"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 439.5,
    cy: 25.5,
    r: 9,
    fill: "#7E0339"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M435.177 31.5L436.315 26.6934L432.5 23.4605L437.54 23.0329L439.5 18.5L441.46 23.0329L446.5 23.4605L442.685 26.6934L443.822 31.5L439.5 28.9513L435.177 31.5Z",
    fill: "#FFCE55"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 38.5,
    y1: 71.5,
    x2: 112.5,
    y2: 71.5,
    stroke: "#FD6F12",
    strokeWidth: 2,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 38.5,
    y1: 78.5,
    x2: 83.5,
    y2: 78.5,
    stroke: "#FD6F12",
    strokeWidth: 2,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.5936 81.063C41.5404 81.3019 41.4154 81.5189 41.2354 81.6847C41.0554 81.8506 40.829 81.9574 40.5866 81.991C40.3441 82.0245 40.0972 81.9831 39.8789 81.8722C39.6607 81.7614 39.4816 81.5865 39.3656 81.371L37.2756 78.278L32.3686 83.185C32.2695 83.2841 32.1518 83.3627 32.0224 83.4163C31.8929 83.4699 31.7542 83.4975 31.6141 83.4975C31.4739 83.4975 31.3352 83.4699 31.2057 83.4163C31.0763 83.3627 30.9586 83.2841 30.8596 83.185L29.8126 82.138C29.7135 82.0389 29.6349 81.9213 29.5812 81.7918C29.5276 81.6624 29.5 81.5236 29.5 81.3835C29.5 81.2434 29.5276 81.1046 29.5812 80.9752C29.6349 80.8457 29.7135 80.7281 29.8126 80.629L34.7196 75.722L31.6066 73.632C31.391 73.5159 31.2162 73.3367 31.1054 73.1184C30.9947 72.9001 30.9533 72.6531 30.987 72.4106C31.0206 72.1682 31.1276 71.9418 31.2936 71.7618C31.4595 71.5819 31.6766 71.457 31.9156 71.404L45.4976 67.5L41.5936 81.063Z",
    fill: "white",
    stroke: "black",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_46_240",
    x: 21.5,
    y: 13.5,
    width: 431,
    height: 76,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: -2,
    dy: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.996078 0 0 0 0 0.435294 0 0 0 0 0.0627451 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_46_240"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_46_240",
    result: "shape"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTextSlate);
export default __webpack_public_path__ + "static/media/text_slate.c5a7e1d21016a2b4591cdd354dbaa199.svg";
export { ForwardRef as ReactComponent };